import andrey from "../../assets/images/Team/Andrey.jpg";
import alex from "../../assets/images/Team/Alexander.jpg";
import nik from "../../assets/images/Team/Nikolay_2.jpg";
import yelzhas from "../../assets/images/Team/Yelzhas.jpg";


export const teamData = [
  {
    name: "Елжас Ахметов",
    photo: yelzhas,
    description: "Chief Executive Officer (CEO) — генеральный деректор",
    link: "https://www.linkedin.com/in/yelzhas-akhmetov-723958122/",
    telegram: "https://t.me/Yelzhas"
  },
  {
    name: "Николай Корниюк",
    photo: nik,
    description: "Сhief strategic planning officer (CSPO) — директор по стратегическому развитию",
    link: "https://www.linkedin.com/in/%D0%BD%D0%B8%D0%BA%D0%BE%D0%BB%D0%B0%D0%B9-%D0%BA%D0%BE%D1%80%D0%BD%D0%B8%D1%8E%D0%BA-84b6b6150/",
    telegram: "https://t.me/nikolaykornijuk"
  },
  {
    name: "Александр Счастный",
    photo: alex,
    description: "Сhief technical officer (CTO) — технический директор",
    link: "https://www.linkedin.com/in/aliaksandr-shchasny-0051661b6/",
    telegram: "https://t.me/aschasny"
  },
  {
    name: "Андрей Оленников",
    photo: andrey,
    description: "Operation leader — руководитель по разработке проекта, Front-end developer",
    link: "https://www.linkedin.com/in/andrey-olennikov-255313233/",
    telegram: "https://t.me/olennikovAndrey_dev"
  },
];
